;(function () {

  // ---- zoom overlay ----
  var openAltZoom = function (src) {
    var overlay = document.createElement('div')
    overlay.className = 'alt-zoom-overlay'
    overlay.setAttribute('tabindex', '-1')
    overlay.innerHTML =
      '<button type="button" class="alt-zoom-overlay__close" aria-label="Close zoom">×</button>' +
      '<div class="alt-zoom-overlay__controls">' +
        '<button type="button" class="alt-zoom-overlay__zoom-out" aria-label="Zoom out">−</button>' +
        '<span class="alt-zoom-overlay__level">100%</span>' +
        '<button type="button" class="alt-zoom-overlay__zoom-in" aria-label="Zoom in">+</button>' +
      '</div>' +
      '<div class="alt-zoom-overlay__inner">' +
        '<img src="' + src + '" alt="" class="alt-zoom-overlay__img" draggable="false" />' +
      '</div>'

    var inner = overlay.querySelector('.alt-zoom-overlay__inner')
    var img = overlay.querySelector('.alt-zoom-overlay__img')
    var levelDisplay = overlay.querySelector('.alt-zoom-overlay__level')
    var closeBtn = overlay.querySelector('.alt-zoom-overlay__close')
    var zoomInBtn = overlay.querySelector('.alt-zoom-overlay__zoom-in')
    var zoomOutBtn = overlay.querySelector('.alt-zoom-overlay__zoom-out')

    var scale = 2, posX = 0, posY = 0
    var isDragging = false, startX, startY, startPosX, startPosY
    var minScale = 0.5, maxScale = 4, zoomStep = 0.25
    var lastPinchDist = null

    var updateTransform = function () {
      img.style.transform = 'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')'
      levelDisplay.textContent = Math.round(scale * 100) + '%'
    }
    var setScale = function (s) {
      scale = Math.min(maxScale, Math.max(minScale, s))
      updateTransform()
    }
    var handleWheel = function (e) {
      e.preventDefault()
      setScale(scale + (e.deltaY > 0 ? -zoomStep : zoomStep))
    }
    var handlePointerDown = function (e) {
      if (e.target.closest('button')) return
      isDragging = true
      startX = e.clientX; startY = e.clientY
      startPosX = posX; startPosY = posY
      inner.style.cursor = 'grabbing'
    }
    var handlePointerMove = function (e) {
      if (!isDragging) return
      posX = startPosX + (e.clientX - startX)
      posY = startPosY + (e.clientY - startY)
      updateTransform()
    }
    var handlePointerUp = function () {
      isDragging = false
      inner.style.cursor = scale > 1 ? 'grab' : 'default'
    }
    var handleTouchMove = function (e) {
      if (e.touches.length === 2) {
        e.preventDefault()
        var dist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY)
        if (lastPinchDist !== null) setScale(scale + (dist - lastPinchDist) * 0.008)
        lastPinchDist = dist
      } else {
        lastPinchDist = null
      }
    }
    var handleTouchEnd = function () { lastPinchDist = null }

    var close = function () {
      overlay.remove()
      document.body.style.overflow = ''
      inner.removeEventListener('wheel', handleWheel, { passive: false })
      inner.removeEventListener('touchmove', handleTouchMove, { passive: false })
      inner.removeEventListener('touchend', handleTouchEnd)
      document.removeEventListener('pointermove', handlePointerMove)
      document.removeEventListener('pointerup', handlePointerUp)
    }

    closeBtn.addEventListener('click', close)
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close() })
    overlay.addEventListener('keydown', function (e) { if (e.key === 'Escape') close() })
    zoomInBtn.addEventListener('click', function () { setScale(scale + zoomStep) })
    zoomOutBtn.addEventListener('click', function () { setScale(scale - zoomStep) })
    inner.addEventListener('wheel', handleWheel, { passive: false })
    inner.addEventListener('touchmove', handleTouchMove, { passive: false })
    inner.addEventListener('touchend', handleTouchEnd)
    inner.addEventListener('pointerdown', handlePointerDown)
    document.addEventListener('pointermove', handlePointerMove)
    document.addEventListener('pointerup', handlePointerUp)
    img.addEventListener('load', function () { inner.style.cursor = scale > 1 ? 'grab' : 'default' })

    document.body.appendChild(overlay)
    document.body.style.overflow = 'hidden'
    overlay.focus()
  }

  // ---- colour picker scroll arrows (mobile) ----
  var initColorScrollArrows = function () {
    document.querySelectorAll('.product-section--alt .product-form__controls--colors').forEach(function (fieldset) {
      if (fieldset._arrowsInit) return
      fieldset._arrowsInit = true

      var group = fieldset.querySelector('.product-form__controls-group')
      if (!group) return

      var wrapper = document.createElement('div')
      wrapper.className = 'alt-color-scroll-wrapper'

      var prevBtn = document.createElement('button')
      prevBtn.type = 'button'
      prevBtn.className = 'alt-color-scroll-btn alt-color-scroll-btn--prev'
      prevBtn.setAttribute('aria-label', 'Scroll colours left')
      prevBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'

      var nextBtn = document.createElement('button')
      nextBtn.type = 'button'
      nextBtn.className = 'alt-color-scroll-btn alt-color-scroll-btn--next'
      nextBtn.setAttribute('aria-label', 'Scroll colours right')
      nextBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'

      group.parentNode.insertBefore(wrapper, group)
      wrapper.appendChild(prevBtn)
      wrapper.appendChild(group)
      wrapper.appendChild(nextBtn)

      var scrollAmt = 130

      var updateBtns = function () {
        prevBtn.classList.toggle('alt-color-scroll-btn--disabled', group.scrollLeft <= 0)
        nextBtn.classList.toggle('alt-color-scroll-btn--disabled', group.scrollLeft >= group.scrollWidth - group.clientWidth - 1)
      }

      prevBtn.addEventListener('click', function () {
        group.scrollBy({ left: -scrollAmt, behavior: 'smooth' })
      })
      nextBtn.addEventListener('click', function () {
        group.scrollBy({ left: scrollAmt, behavior: 'smooth' })
      })

      group.addEventListener('scroll', updateBtns)
      updateBtns()

      // Touch drag: manually scroll and block the page from stealing horizontal swipes
      var _tx = 0, _ty = 0, _sl = 0, _isH = null
      group.addEventListener('touchstart', function (e) {
        _tx = e.touches[0].clientX
        _ty = e.touches[0].clientY
        _sl = group.scrollLeft
        _isH = null
      }, { passive: true })
      group.addEventListener('touchmove', function (e) {
        var dx = e.touches[0].clientX - _tx
        var dy = e.touches[0].clientY - _ty
        if (_isH === null) _isH = Math.abs(dx) > Math.abs(dy)
        if (!_isH) return
        e.preventDefault()
        group.scrollLeft = _sl - dx
        updateBtns()
      }, { passive: false })
    })
  }

  // ---- thumbnail toggle ----
  var initAltGalleries = function () {
    document.querySelectorAll('[data-alt-gallery]').forEach(function (gallery) {
      if (gallery._altInit) return
      gallery._altInit = true
      gallery._altShowingBack = false

      var heroImg = gallery.querySelector('[data-alt-hero-img]')
      if (!heroImg) return

      // zoom on hero click
      heroImg.addEventListener('click', function () {
        var zoomSrc = heroImg.dataset.zoomSrc || heroImg.currentSrc || heroImg.src
        if (zoomSrc) openAltZoom(zoomSrc)
      })

      var thumbBtn = gallery.querySelector('[data-alt-thumb]')
      if (!thumbBtn) return

      var thumbImg = thumbBtn.querySelector('img')
      var thumbLabel = thumbBtn.querySelector('.alt-gallery__thumb-label')

      thumbBtn.addEventListener('click', function () {
        gallery._altShowingBack = !gallery._altShowingBack
        if (gallery._altShowingBack) {
          heroImg.src = thumbBtn.dataset.backSrc
          heroImg.srcset = thumbBtn.dataset.backSrcset
          heroImg.dataset.zoomSrc = thumbBtn.dataset.backZoom || thumbBtn.dataset.backSrc
          if (thumbImg) thumbImg.src = thumbBtn.dataset.thumbFrontSrc
          if (thumbLabel) thumbLabel.textContent = 'View front'
          thumbBtn.setAttribute('aria-label', 'View front')
        } else {
          heroImg.src = thumbBtn.dataset.frontSrc
          heroImg.srcset = thumbBtn.dataset.frontSrcset
          heroImg.dataset.zoomSrc = thumbBtn.dataset.frontZoom || thumbBtn.dataset.frontSrc
          if (thumbImg) thumbImg.src = thumbBtn.dataset.thumbBackSrc
          if (thumbLabel) thumbLabel.textContent = 'View back'
          thumbBtn.setAttribute('aria-label', 'View back')
        }
      })
    })
  }

  // ---- mobile hero carousel ----
  var initMobileHeroCarousel = function () {
    document.querySelectorAll('[data-alt-gallery]').forEach(function (gallery) {
      if (gallery._carouselInit) return
      gallery._carouselInit = true

      var heroWrap = gallery.querySelector('.alt-gallery__hero')
      var heroImg = gallery.querySelector('[data-alt-hero-img]')
      var thumbBtn = gallery.querySelector('[data-alt-thumb]')
      var mediaJsonEl = gallery.querySelector('.alt-media-json')
      if (!heroWrap || !heroImg || !mediaJsonEl) return

      var sectionId = gallery.dataset.section

      var mediaList
      try { mediaList = JSON.parse(mediaJsonEl.textContent) } catch (e) { return }

      var frontImages = mediaList.filter(function (m) { return m.alt === 'front' })
      var backImages  = mediaList.filter(function (m) { return m.alt === 'back' })

      // Build slides ordered by the colour picker swatch sequence
      var slides = []
      var swatchOrder = [] // pairIdx values in the order swatches appear in the DOM

      var allVarsEl = document.querySelector('#variant-picker-' + sectionId + ' [data-all-variants-no-high]')
      var allVars = []
      try { if (allVarsEl) allVars = JSON.parse(allVarsEl.textContent) } catch (e) {}

      var cwFieldset = document.querySelector('.product-section--alt .product-form__controls--colors')
      if (cwFieldset && allVars.length) {
        var swRadios = cwFieldset.querySelectorAll('input[type="radio"]')
        for (var ri = 0; ri < swRadios.length; ri++) {
          var swVid = Number(swRadios[ri].dataset.variantId)
          var swVar = null
          for (var vi = 0; vi < allVars.length; vi++) {
            if (allVars[vi].id === swVid) { swVar = allVars[vi]; break }
          }
          if (!swVar || !swVar.featured_media) continue
          var swFid = Number(swVar.featured_media.id)
          for (var fii = 0; fii < frontImages.length; fii++) {
            if (Number(frontImages[fii].id) === swFid) {
              var dupFound = false
              for (var di = 0; di < swatchOrder.length; di++) {
                if (swatchOrder[di] === fii) { dupFound = true; break }
              }
              if (!dupFound) swatchOrder.push(fii)
              break
            }
          }
        }
      }

      // Add pairs in swatch order, then any orphan pairs not covered by swatches
      var addedPairs = []
      var addPair = function (pairIdx) {
        for (var ai = 0; ai < addedPairs.length; ai++) {
          if (addedPairs[ai] === pairIdx) return
        }
        addedPairs.push(pairIdx)
        if (frontImages[pairIdx]) slides.push({ media: frontImages[pairIdx], side: 'front', pairIdx: pairIdx })
        if (backImages[pairIdx])  slides.push({ media: backImages[pairIdx],  side: 'back',  pairIdx: pairIdx })
      }
      for (var soi = 0; soi < swatchOrder.length; soi++) addPair(swatchOrder[soi])
      var maxPairs = Math.max(frontImages.length, backImages.length)
      for (var pi = 0; pi < maxPairs; pi++) addPair(pi)

      if (slides.length <= 1) return

      // Set initial carousel position to match the currently selected variant
      var currentSlide = 0
      var selVarEl = document.querySelector('#variant-picker-' + sectionId + ' [data-selected-variant]')
      if (selVarEl) {
        var selVar
        try { selVar = JSON.parse(selVarEl.textContent) } catch (e) {}
        if (selVar && selVar.featured_media) {
          var initFid = Number(selVar.featured_media.id)
          for (var ii = 0; ii < slides.length; ii++) {
            if (Number(slides[ii].media.id) === initFid) { currentSlide = ii; break }
          }
        }
      }

      // --- arrow buttons (CSS hides them on desktop) ---
      var prevArrow = document.createElement('button')
      prevArrow.type = 'button'
      prevArrow.className = 'alt-gallery__hero-arrow alt-gallery__hero-arrow--prev'
      prevArrow.setAttribute('aria-label', 'Previous image')
      prevArrow.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M11 3L5 9L11 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'

      var nextArrow = document.createElement('button')
      nextArrow.type = 'button'
      nextArrow.className = 'alt-gallery__hero-arrow alt-gallery__hero-arrow--next'
      nextArrow.setAttribute('aria-label', 'Next image')
      nextArrow.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M7 3L13 9L7 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'

      heroWrap.appendChild(prevArrow)
      heroWrap.appendChild(nextArrow)

      // --- keep thumb button in sync with current slide ---
      var syncThumb = function (slide) {
        if (!thumbBtn) return
        var pairIdx  = slide.pairIdx
        var frontMed = frontImages[pairIdx]
        var backMed  = backImages[pairIdx]
        var thumbImg   = thumbBtn.querySelector('img')
        var thumbLabel = thumbBtn.querySelector('.alt-gallery__thumb-label')

        if (frontMed) {
          thumbBtn.dataset.frontSrc    = frontMed.src
          thumbBtn.dataset.frontSrcset = frontMed.srcset
          thumbBtn.dataset.frontZoom   = frontMed.zoom || frontMed.src
          thumbBtn.dataset.thumbFrontSrc = frontMed.src200
        }
        if (backMed) {
          thumbBtn.dataset.backSrc    = backMed.src
          thumbBtn.dataset.backSrcset = backMed.srcset
          thumbBtn.dataset.backZoom   = backMed.zoom || backMed.src
          thumbBtn.dataset.thumbBackSrc = backMed.src200
        }

        if (slide.side === 'front') {
          gallery._altShowingBack = false
          if (thumbImg)   thumbImg.src = backMed ? backMed.src200 : thumbBtn.dataset.thumbBackSrc
          if (thumbLabel) thumbLabel.textContent = 'View back'
          thumbBtn.setAttribute('aria-label', 'View back')
        } else {
          gallery._altShowingBack = true
          if (thumbImg)   thumbImg.src = frontMed ? frontMed.src200 : thumbBtn.dataset.thumbFrontSrc
          if (thumbLabel) thumbLabel.textContent = 'View front'
          thumbBtn.setAttribute('aria-label', 'View front')
        }
      }

      var updateArrows = function () {
        prevArrow.disabled = currentSlide === 0
        nextArrow.disabled = currentSlide === slides.length - 1
      }

      // --- sync colour picker when carousel navigates (mobile only) ---
      var selectColourForSlide = function (slide) {
        if (window.innerWidth >= 990) return
        var frontMed = frontImages[slide.pairIdx]
        if (!frontMed) return

        var variantsEl = document.querySelector('#variant-picker-' + sectionId + ' [data-all-variants-no-high]')
        if (!variantsEl) return
        var variants
        try { variants = JSON.parse(variantsEl.textContent) } catch (e) { return }

        // Find variant whose featured_media maps to this colour's front image
        var matched = null
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].featured_media && Number(variants[i].featured_media.id) === Number(frontMed.id)) {
            matched = variants[i]; break
          }
        }
        if (!matched) return

        var colourFieldset = document.querySelector('.product-section--alt .product-form__controls--colors')
        if (!colourFieldset) return
        var optionPos   = Number(colourFieldset.dataset.optionPosition) || 1
        var colourValue = matched['option' + optionPos]
        if (!colourValue) return

        // Find the radio for this colour value
        var radios = colourFieldset.querySelectorAll('input[type="radio"]')
        var targetRadio = null
        for (var j = 0; j < radios.length; j++) {
          if (radios[j].value === colourValue) { targetRadio = radios[j]; break }
        }
        if (!targetRadio || targetRadio.checked) return

        // Update the colour name label immediately
        var colorNameEl = colourFieldset.querySelector('[id^="ColorName-"]')
        if (colorNameEl) colorNameEl.textContent = colourValue

        // Flag: tell handleVariantChange not to reset the carousel
        gallery._carouselNavigating = true

        // Trigger full variant-change (price, ATC button, availability, etc.)
        targetRadio.click()
      }

      var goToSlide = function (idx) {
        if (idx < 0 || idx >= slides.length) return
        currentSlide = idx
        var slide = slides[idx]
        heroImg.src            = slide.media.src
        heroImg.srcset         = slide.media.srcset
        heroImg.dataset.zoomSrc = slide.media.zoom || slide.media.src
        syncThumb(slide)
        updateArrows()
        selectColourForSlide(slide)
      }

      prevArrow.addEventListener('click', function () { goToSlide(currentSlide - 1) })
      nextArrow.addEventListener('click', function () { goToSlide(currentSlide + 1) })

      // After the existing thumb-toggle handler runs, re-sync the carousel index
      if (thumbBtn) {
        thumbBtn.addEventListener('click', function () {
          var curPairIdx = slides[currentSlide] ? slides[currentSlide].pairIdx : 0
          var targetSide = gallery._altShowingBack ? 'back' : 'front'
          for (var k = 0; k < slides.length; k++) {
            if (slides[k].pairIdx === curPairIdx && slides[k].side === targetSide) {
              currentSlide = k; break
            }
          }
          updateArrows()
        })
      }

      // Called by handleVariantChange to reset carousel to the front of a new colour
      gallery._carouselGoToMedia = function (mediaId) {
        var id = Number(mediaId)
        for (var k = 0; k < slides.length; k++) {
          if (Number(slides[k].media.id) === id) { goToSlide(k); return }
        }
      }

      updateArrows()
    })
  }

  // ---- variant change ----
  var handleVariantChange = function (data) {
    var variant = data && data.data && data.data.variant
    if (!variant || !variant.featured_media) return

    document.querySelectorAll('[data-alt-gallery]').forEach(function (gallery) {
      // Carousel triggered this variant change — skip gallery reset so we don't
      // clobber the carousel position back to the front image
      if (gallery._carouselNavigating) {
        gallery._carouselNavigating = false
        return
      }

      var heroImg = gallery.querySelector('[data-alt-hero-img]')
      if (!heroImg) return

      var mediaJsonEl = gallery.querySelector('.alt-media-json')
      if (!mediaJsonEl) return

      var mediaList
      try { mediaList = JSON.parse(mediaJsonEl.textContent) } catch (e) { return }

      var featuredId = Number(variant.featured_media.id)
      var frontMedia = mediaList.find(function (m) { return Number(m.id) === featuredId })
      if (!frontMedia) return

      // Match back image by relative order: i-th front → i-th back
      var frontImages = mediaList.filter(function (m) { return m.alt === 'front' })
      var backImages = mediaList.filter(function (m) { return m.alt === 'back' })
      var frontIdx = -1
      for (var i = 0; i < frontImages.length; i++) {
        if (Number(frontImages[i].id) === featuredId) { frontIdx = i; break }
      }
      var backMedia = (frontIdx !== -1 && frontIdx < backImages.length) ? backImages[frontIdx] : null

      // Update hero
      heroImg.src = frontMedia.src
      heroImg.srcset = frontMedia.srcset
      heroImg.dataset.zoomSrc = frontMedia.zoom || frontMedia.src

      // Update thumb button data attrs and reset toggle UI
      gallery._altShowingBack = false
      var thumbBtn = gallery.querySelector('[data-alt-thumb]')
      if (thumbBtn) {
        thumbBtn.dataset.frontSrc = frontMedia.src
        thumbBtn.dataset.frontSrcset = frontMedia.srcset
        thumbBtn.dataset.frontZoom = frontMedia.zoom || frontMedia.src
        thumbBtn.dataset.thumbFrontSrc = frontMedia.src200
        if (backMedia) {
          thumbBtn.dataset.backSrc = backMedia.src
          thumbBtn.dataset.backSrcset = backMedia.srcset
          thumbBtn.dataset.backZoom = backMedia.zoom || backMedia.src
          thumbBtn.dataset.thumbBackSrc = backMedia.src200
        }
        var thumbImg = thumbBtn.querySelector('img')
        var thumbLabel = thumbBtn.querySelector('.alt-gallery__thumb-label')
        if (thumbImg) thumbImg.src = backMedia ? backMedia.src200 : thumbBtn.dataset.thumbBackSrc
        if (thumbLabel) thumbLabel.textContent = 'View back'
        thumbBtn.setAttribute('aria-label', 'View back')
      }

      // Reset carousel to the front of the newly selected colour
      if (typeof gallery._carouselGoToMedia === 'function') {
        gallery._carouselGoToMedia(featuredId)
      }
    })
  }

  // ---- mobile stacking: move tags/title/price above gallery on mobile ----
  var initMobileStack = function () {
    document.querySelectorAll('.product-section--alt').forEach(function (section) {
      if (section._mobileStackInit) return
      section._mobileStackInit = true

      var infoContainer = section.querySelector('.product__info-container')
      var outer = section.querySelector('.product__outer')
      if (!infoContainer || !outer) return

      var tagsEl = infoContainer.querySelector('.product__tags')
      var titleEl = infoContainer.querySelector('.product__title__wrapper')
      var priceEl = infoContainer.querySelector('.price-wrapper')
      var installEl = infoContainer.querySelector('.installment-wrapper')
      var toMove = [tagsEl, titleEl, priceEl, installEl].filter(Boolean)
      if (toMove.length === 0) return

      var mobileTop = document.createElement('div')
      mobileTop.className = 'alt-mobile-top'
      outer.appendChild(mobileTop)

      var isMobile = false

      var applyLayout = function () {
        var nowMobile = window.innerWidth < 990
        if (nowMobile === isMobile) return
        isMobile = nowMobile
        if (nowMobile) {
          toMove.forEach(function (el) { mobileTop.appendChild(el) })
        } else {
          var anchor = infoContainer.firstChild
          toMove.forEach(function (el) { infoContainer.insertBefore(el, anchor) })
        }
      }

      applyLayout()

      var resizeTimer
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(applyLayout, 100)
      })
    })
  }

  // ---- boot ----
  var boot = function () {
    initAltGalleries()
    initMobileHeroCarousel()
    initMobileStack()
    if (typeof subscribe === 'function') {
      subscribe('variant-change', handleVariantChange)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }

  document.addEventListener('shopify:section:load', function () {
    initAltGalleries()
    initMobileHeroCarousel()
    initMobileStack()
  })

  window.altProductInit = function () {
    initAltGalleries()
    initMobileHeroCarousel()
    initMobileStack()
  }

  window.altInitMobileStackIn = function (outer) {
    if (!outer || outer._altMobileStack) return
    outer._altMobileStack = true

    var infoContainer = outer.querySelector('.product__info-container')
    if (!infoContainer) return

    var titleEl = infoContainer.querySelector('.product__title__wrapper')
    var priceEl = infoContainer.querySelector('.price-wrapper')
    var installEl = infoContainer.querySelector('.installment-wrapper')
    var toMove = [titleEl, priceEl, installEl].filter(Boolean)
    if (toMove.length === 0) return

    var mobileTop = outer.querySelector('.alt-mobile-top')
    if (!mobileTop) {
      mobileTop = document.createElement('div')
      mobileTop.className = 'alt-mobile-top'
      outer.appendChild(mobileTop)
    }

    if (window.innerWidth < 990) {
      toMove.forEach(function (el) { mobileTop.appendChild(el) })
    }
  }
})()
